export default __webpack_public_path__ + "static/media/002-payment.6fc2faaf.svg";